import React, {Fragment} from 'react';
import {
    BulkDeleteButton,
    ChipField,
    Create,
    CreateButton,
    Datagrid,
    Edit,
    EditButton,
    Filter,
    List,
    NumberInput,
    ReferenceArrayField,
    ReferenceArrayInput,
    ReferenceField,
    ReferenceInput,
    SelectArrayInput,
    SelectInput,
    SimpleForm,
    SingleFieldList,
    TextField,
    TextInput,
    translate,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import Toolbar from '@material-ui/core/Toolbar';
import DateInput from '../../../../components/DateInput';

import LinkToList from './LinkToList';
import resourceLocales from './locales';
import resourceConfig from './config';
import documentRowStyle from '../../../../utils/ui/documentRowStyle';
import exporter from '../../../../utils/exporter';
import Update from './Update';
import PostPagination from '../../../../utils/pagination';
import ExportDocButton from './ExportDocButton';
import errorModel from "../errorModel";
import objectSendModel from "../objectSendModel";
import Send from "./Send";
import EnumField from "../../../../components/EnumField";
import EnumInput from "../../../../components/EnumInput";

const ResourceIcon = BookmarkIcon;

const trPrefix = `resources.${resourceConfig.name}`;
const listStyles = {};


const ResourceBulkActionButtons = (props) => (
    <Fragment>
        <Update {...props} />
        <Send {...props} />
        <BulkDeleteButton {...props} />
    </Fragment>
);

const ResourceListFilter = (props) => (
    <Filter {...props}>
        <TextInput source={'batchNumber'}/>
        <TextInput source={'gtin'}/>
        <DateInput
            source={'productionDate'}
            label={`resources.${resourceConfig.name}.fields.productionDate`}
        />
        <NumberInput source={'quantity'}/>
        <TextInput source={'status'}/>
        <TextInput source={'systemStatus'}/>
        <DateInput
            source={'creationDate'}
            label={`resources.${resourceConfig.name}.fields.creationDate`}
        />
    </Filter>
);
const ResourceListActions = ({
                                 bulkActions,
                                 basePath,
                                 currentSort,
                                 displayedFilters,
                                 exporter,
                                 filters,
                                 filterValues,
                                 onUnselectItems,
                                 resource,
                                 selectedIds,
                                 showFilter,
                                 total
                             }) => (
    <Toolbar>
        {bulkActions &&
            React.cloneElement(bulkActions, {
                basePath,
                filterValues,
                resource,
                selectedIds,
                onUnselectItems,
            })}
        {filters &&
            React.cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
        {/*<documentImport.OpenButton params={{ docType: 'DOC' }} />*/}
        {/*<docHMassInput.OpenButton />*/}
        {/*<CreateDocEaeuReport filter={filterValues} />*/}
        <CreateButton basePath={basePath}/>
        <ExportDocButton
            disabled={total === 0}
            resource={resource}
            sort={currentSort}
            filter={filterValues}
            exporter={exporter}
            basePath={basePath}
            resourceConfig={resourceConfig}
        />
        {/*<docLoadCustom.OpenButton />*/}
    </Toolbar>
);

const ResourceList = withStyles(listStyles)(({classes, ...props}) => (
    <List
        {...props}
        actions={<ResourceListActions/>}
        filters={<ResourceListFilter/>}
        sort={{field: 'id', order: 'DESC'}}
        bulkActionButtons={<ResourceBulkActionButtons/>}
        exporter={exporter}
        pagination={<PostPagination/>}>
        <Datagrid rowStyle={documentRowStyle}>
            <TextField source={'id'}/>
            <TextField source={'batchNumber'}/>
            <TextField source={'gtin'}/>
            <TextField source={'productionDate'}/>
            <TextField source={'quantity'}/>
            <TextField source={'status'}/>
            <errorModel.LinkToRelatedList type={'BATCH_INFO'}/>
            <objectSendModel.LinkToRelatedList type={'BATCH_INFO'}/>
            <EditButton/>
        </Datagrid>
    </List>
));

const ResourceTitle = translate(({record, translate}) => (
    <span>
    {translate(`resources.${resourceConfig.name}.name`, {smart_count: 1})} &quot;{record.name}
        &quot;
  </span>
));

const ResourceCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source={'batchNumber'}/>
            <TextInput source={'gtin'}/>
            <DateInput
                source={'productionDate'}
                label={`resources.${resourceConfig.name}.fields.productionDate`}
            />
            <NumberInput source={'quantity'}/>
            <TextInput source={'systemStatus'}
                       translatePrefix={`${trPrefix}.enums.status.`}
                       label={`${trPrefix}.fields.status`}
                       enums={resourceConfig.enums.status}
            />
            <TextInput source={'status'}/>
            <DateInput
                source={'creationDate'}
                label={`resources.${resourceConfig.name}.fields.creationDate`}
            />
        </SimpleForm>
    </Create>
);

const ResourceEdit = (props) => (
    <Edit redirect={null} undoable={false} title={<ResourceTitle/>} {...props}>
        <SimpleForm redirect={false}>
            <TextField source={'id'}/>
            <TextInput source={'batchNumber'}/>
            <TextInput source={'gtin'}/>
            <DateInput
                source={'productionDate'}
                label={`resources.${resourceConfig.name}.fields.productionDate`}
            />
            <NumberInput source={'quantity'}/>
            <EnumInput source={'systemStatus'}
                       translatePrefix={`${trPrefix}.enums.status.`}
                       label={`${trPrefix}.fields.status`}
                       enums={resourceConfig.enums.status}
            />
            <TextInput source={'status'}/>
            <DateInput
                source={'creationDate'}
                label={`resources.${resourceConfig.name}.fields.creationDate`}
            />
        </SimpleForm>
    </Edit>
);

const ResourceReferenceField = (props) => (
    <ReferenceField reference={resourceConfig.name} {...props}>
        <TextField source={'id'}/>
    </ReferenceField>
);

const ResourceReferenceArrayField = (props) => (
    <ReferenceArrayField reference={resourceConfig.name} {...props}>
        <SingleFieldList>
            <ChipField source={'id'}/>
        </SingleFieldList>
    </ReferenceArrayField>
);

const ResourceReferenceInput = (props) => (
    <ReferenceInput reference={resourceConfig.name} {...props}>
        <SelectInput optionText={'id'}/>
    </ReferenceInput>
);

const ResourceReferenceArrayInput = (props) => (
    <ReferenceArrayInput reference={resourceConfig.name} {...props}>
        <SelectArrayInput optionText={'id'}/>
    </ReferenceArrayInput>
);

export default {
    Icon: ResourceIcon,
    List: ResourceList,
    Title: ResourceTitle,
    Create: ResourceCreate,
    Edit: ResourceEdit,
    Field: ResourceReferenceField,
    ArrayField: ResourceReferenceArrayField,
    Input: ResourceReferenceInput,
    ArrayInput: ResourceReferenceArrayInput,
    LinkToList,

    name: resourceConfig.name,
    resourceConfig: {
        name: resourceConfig.name,
        list: ResourceList,
        edit: ResourceEdit,
        create: ResourceCreate,
        icon: ResourceIcon,
    },
    menuConfig: {
        name: resourceConfig.name,
        icon: ResourceIcon,
    },
    locales: resourceLocales,
    restProviderResolve: {
        name: resourceConfig.name,
        apiService: resourceConfig.apiService,
        basePath: resourceConfig.apiPath,
        schema: {
            productionDate: {
                type: 'date',
            },
            creationDate: {
                type: 'dateTime',
            }
        },
        filters: {
            productionDate: {
                type: 'date',
            },
            creationDate: {
                type: 'dateTime',
            }
        },
    },
};
